import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ToolbarButtonComponent } from './toolbar-button/toolbar-button.component';
import { TooltipModule } from 'primeng/tooltip';
import { CtPage } from '../../model/ct-batch-model';
import { FitType } from '../fit-type';
import { ClaimsToastService } from '../../toast/claims-toast.service';
import { TooltipDirective } from '@vydaps/gui-commons';
import { DocumentSearchPopoverComponent } from '../document-search-popover/document-search-popover.component';
import { SearchQuery } from '../../document-search/document-search-api.service';
import { FloatingElementDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'ct-shared-preview-tool-bar',
  imports: [
    ToolbarButtonComponent,
    TooltipModule,
    TooltipDirective,
    DocumentSearchPopoverComponent,
    FloatingElementDirective,
  ],
  templateUrl: './preview-tool-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewToolBarComponent {
  readonly currentPageIndex = input.required<number | undefined>();
  readonly totalPageCount = input.required<number>();
  readonly currentPage = input.required<CtPage>();
  readonly fitType = input.required<FitType>();
  readonly foundWordsCount = input.required<number | undefined>();

  readonly toggleFitType = output();
  readonly zoomChange = output<number>();
  readonly searchQueried = output<SearchQuery>();
  readonly searchClear = output();

  private readonly toastService = inject(ClaimsToastService);

  protected onRotateClicked() {
    this.toastService.error(
      `Funktion zurzeit nicht verfügbar. Bitte Seiten-ID an Julian weitergeben: ${this.currentPage().id}`,
    );
  }
  readonly zoomStep: number = 0.3;
}
